import { ToastContext } from './ToastContext.js';

const ToastConsumer = ToastContext.Consumer;

export { ToastConsumer as default };
